var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarehouse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0E141A",
  d: "M14.667 38.5H7.333q-1.511 0-2.588-1.076-1.078-1.078-1.078-2.59V15.309q0-1.146.62-2.063a3.5 3.5 0 0 1 1.671-1.329L20.625 6.05A3.5 3.5 0 0 1 22 5.775q.733 0 1.375.275l14.667 5.867q1.053.412 1.673 1.33.618.915.618 2.062v19.525q0 1.513-1.076 2.59t-2.59 1.076h-7.334V23.834H14.667zm1.833 0v-3.666h3.667V38.5zm3.667-5.5v-3.666h3.666V33zm3.666 5.5v-3.666H27.5V38.5z"
})));
export { SvgWarehouse as ReactComponent };
export default __webpack_public_path__ + "static/media/warehouse.46a6d97d.svg";